import React, { useCallback, useMemo, useState } from 'react';
import { useExodus } from '@exodus/headless-ui';
import useCurrentEffect from '@exodus/react-hooks/common/useCurrentEffect';
import searchAssets from './search-assets.js';
import useBaseAssets from './use-base-assets.js';
const Select = ({ Component, side, assets, walletAccount, walletAccounts, loading, onSearch, onSelect, onWalletAccountChange, ...rest }) => {
    const exodus = useExodus();
    const [query, setQuery] = useState('');
    const all = useBaseAssets({ assets, walletAccount, query });
    const [remoteSearch, setRemoteSearch] = useState([]);
    const localSearch = useMemo(() => searchAssets(all, query), [all, query]);
    const search = useMemo(() => {
        const assetMap = new Map();
        for (const asset of localSearch) {
            assetMap.set(asset.name, asset);
        }
        for (const asset of remoteSearch) {
            const key = asset.name;
            if (!assetMap.has(key)) {
                assetMap.set(key, asset);
            }
        }
        return [...assetMap.values()];
    }, [localSearch, remoteSearch]);
    const assetsObject = useMemo(() => ({ all, search }), [all, search]);
    const handleSelect = useCallback((source) => {
        onSelect(source ? { walletAccount, ...source } : null);
    }, [walletAccount, onSelect]);
    useCurrentEffect((isCurrent) => {
        void onSearch?.(exodus, query, walletAccount.toString()).then((assets) => {
            if (!isCurrent())
                return;
            setRemoteSearch(assets);
        });
    }, [query, walletAccount, onSearch, exodus]);
    if (!Component)
        return null;
    return (React.createElement(Component, { side: side, query: query, assets: assetsObject, walletAccount: walletAccount, walletAccounts: walletAccounts, loading: loading, onSelect: handleSelect, onQueryChange: setQuery, onWalletAccountChange: onWalletAccountChange, ...rest }));
};
export default Select;
